export default __webpack_public_path__ + "static/media/NotificationIcon.abdf963c.svg";